export default __webpack_public_path__ + "static/media/ramjhula.d47cf02f.jpg";